const games = [
  "Fortnite", "Valorant", "Counter-Strike 2", "Apex Legends", "Warzone",
  "Rainbow Six Siege", "Rust", "The Finals", "Overwatch 2", "Marvel Rivals",
];

const GamesMarquee = () => {
  const items = [...games, ...games];
  return (
    <section id="games" data-testid="games-marquee" className="py-4 bg-[#ff4655] text-black font-black overflow-hidden uppercase font-display text-2xl tracking-wider">
      <a href="/games" data-testid="games-marquee-link" className="block" title="View all supported games">
        <div className="mq-banner gap-8 items-center">
          {items.map((g, i) => (
            <span key={i} className="flex items-center gap-8">
              <span>{g}</span>
              <span>•</span>
            </span>
          ))}
        </div>
      </a>
    </section>
  );
};

export default GamesMarquee;
